import http from "Utils/api2";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const getAllPermissions = createAsyncThunk("getAllPermissions", async (url) => {
  try {
    const res = await http.get(url);
    return res.data;
  } catch (error) {
    return { data: null };
  }
});

const PermissionsSlice = createSlice({
  name: "PermissionsSlice",
  initialState: {
    permissions: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getAllPermissions.pending, (state, action) => {
        state.Loading = true;
      })
      .addCase(getAllPermissions.fulfilled, (state, action) => {
        state.Loading = false;
        state.permissions = action.payload?.permission;
      })
      .addCase(getAllPermissions.rejected, (state, action) => {
        state.Loading = false;
      });
  },
});
export default PermissionsSlice.reducer;
